import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBolt,
    faBook,
    faBookOpen,
    faBullhorn,
    faClipboard,
    faCrown,
    faExclamationCircle,
    faGenderless,
    faGraduationCap,
    faHome,
    faMedal,
    faUserCircle,
    faUserGraduate,
    faUsers
} from '@fortawesome/free-solid-svg-icons'
import {AiFillClockCircle, AiFillSchedule} from "react-icons/ai";
import {
    FaBookOpen,
    FaBuilding,
    FaGraduationCap,
    FaPhoneVolume,
    FaRegCalendarAlt,
    FaUsers,
    FaWrench
} from "react-icons/fa";

const DIPLOMA = "Диплом";
const DISSERTATION = "Диссертация";

export const PersonalProfileNavigationItems = (user, personalInfo) => {
    return [
        {
            text: "Профиль",
            path: "/personal-account/profile",
            icon: <FontAwesomeIcon icon={faUserCircle} size="lg" />,
            visible: true
        },
        {
            text: "Зачетка",
            path: "/personal-account/markbook",
            icon: <FontAwesomeIcon icon={faBookOpen} size="lg" />,
            visible: true
        },
        {
            text: "Учеба",
            path: "/personal-account/study",
            icon: <FontAwesomeIcon icon={faGraduationCap} size="lg" />,
            visible: true
        },
        {
            text: "Староста",
            path: "/personal-account/headman",
            icon: <FontAwesomeIcon icon={faCrown} size="lg" />,
            visible: user?.isGroupHead || user?.canStudentNote
        },
        {
            text: "Рейтинг",
            path: "/personal-account/rating",
            icon: <FontAwesomeIcon icon={faMedal} size="lg" />,
            visible: true
        },
        {
            text: "Пропуски",
            path: "/personal-account/omissions",
            icon: <FontAwesomeIcon icon={faGenderless} size="lg" />,
            visible: true
        },
        {
            text: "Группа",
            path: "/personal-account/group",
            icon: <FontAwesomeIcon icon={faUsers} size="lg" />,
            visible: true
        },
        {
            text: "Библиотека",
            path: "/personal-account/library",
            icon: <FontAwesomeIcon icon={faBook} size="lg" />,
            visible: true
        },
        {
            text: "Объявления",
            path: "/personal-account/announcements",
            icon: <FontAwesomeIcon icon={faBullhorn} size="lg" />,
            visible: true
        },
        {
            text:`${personalInfo?.degree === 1 ? DIPLOMA : DISSERTATION}`,
            path: "/personal-account/graduate",
            icon: <FontAwesomeIcon icon={faUserGraduate} size="lg" />,
            visible: true
        },
        {
            text: "Общежитие",
            path: "/personal-account/dormitory",
            icon: <FontAwesomeIcon icon={faHome} size="lg" />,
            visible: true
        },
        {
            text: "Взыскания",
            path: "/personal-account/penalty",
            icon: <FontAwesomeIcon icon={faExclamationCircle} size="lg" />,
            visible: true
        },
        {
            text: "Активность",
            path: "/personal-account/social-and-research-work",
            icon: <FontAwesomeIcon icon={faBolt} size="lg" />,
            visible: true
        },
        {
            text: "Профилизация",
            path: "/personal-account/profiling",
            icon: <FontAwesomeIcon icon={faClipboard} size="lg" />,
            visible: user?.hasProfiling
        }
    ]
}

export const SidebarNavigationItems = [
    {
        text: "Расписание",
        path: `/schedule`,
        icon: <FaRegCalendarAlt size={25} />
    },
    {
        text: "Календарь учебных недель",
        path: `/calendar`,
        icon: <AiFillClockCircle size={25} />
    },
    {
        text: "Расписание кафедры",
        path: "/schedule-department",
        icon: <AiFillSchedule size={25} />
    },
    {
        text: "Подразделения",
        path: "/departments",
        icon: <FaBuilding size={25} />
    },
    {
        text: "Студенты",
        path: "/profiles",
        icon: <FaUsers size={25} />
    },
    {
        text: "Рейтинг",
        path: "/rating-of-students",
        icon: <FaGraduationCap size={25} />
    },
    {
        text: "Перечень дисциплин",
        path: "/list-of-disciplines",
        icon: <FaBookOpen size={25} />
    },
    {
        text: "Телефонный справочник",
        path: "/phones",
        icon: <FaPhoneVolume size={25} />
    },
    {
        text: "Техподдержка",
        path: "/support",
        icon: <FaWrench size={25} />
    }
]
